import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import TourTicket from '../models/TourTicket';

const initialState = {
    onSubmitting: false,
    isFetching: false,
    isSubmit: false,
    isFetchingUpdate: false,
    isGetItem: false,
    tourTickets: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    detail: {
        tourTicket: new TourTicket()
    },
    allTourTickets: [],
    isFetchingAllTourTicketsByIds: false,
    allTourTicketsByIds: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.TOUR_TICKET_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.TOUR_TICKET_DELETE_ACTION:
            return { ...state, isFetching: true };
        case Types.TOUR_TICKET_UPDATE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.TOUR_TICKET_UPDATE_SUCCESS:
            return { ...state, isFetching: false, isSubmit: false };
        case Types.TOUR_TICKET_GET_UPDATE_ACTION:
            return { ...state, isFetchingUpdate: true, isGetItem: true };
        case Types.TOUR_TICKET_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                tourTickets: action.tourTickets.result,
                pageSize: action.tourTickets.pageSize,
                pageIndex: action.tourTickets.pageIndex,
                totalCount: action.tourTickets.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case Types.TOUR_TICKET_GET_UPDATE_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                detail: {
                    tourTicket: action.tourTicket
                }
            };
        case Types.TOUR_TICKET_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.TOUR_TICKET_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.TOUR_TICKET_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.TOUR_TICKET_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.TOUR_TICKET_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.TOUR_TICKET_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.TOUR_TICKET_CHECK_ACTION:
            return { ...state, isChecked: true };
        case Types.TOUR_TICKET_CHECK_SUCCESS:
            return { ...state, isFetchingUpdate: false, isChecked: false, resultCheck: action.resultCheck };
        case Types.TOUR_TICKET_RESET:
            return { ...initialState, isFetchingUpdate: false, isChecked: false };
        case Types.TOUR_TICKET_CHECK_FAIL:
            return { ...state, message: action.params.message, isSubmit: false };
        case Types.TOUR_TICKET_RESET:
            state = initialState;
            return { isFetching: false };
        case Types.TOUR_TICKET_LIST_ALL_ACTION:
            return { ...state, allTourTickets: null };
        case Types.TOUR_TICKET_LIST_ALL_SUCCESS:
            return { ...state, allTourTickets: action.tickets.result };
        case Types.TOUR_TICKET_FAIL:
            return { ...state, isFetching: false, isFetchingUpdate: false, isSubmit: false, isGetItem: false };
        case Types.TOUR_TICKET_LIST_ALL_BY_ID_ACTION:
            return { ...state, allTourTicketsByIds: [], isFetchingAllTourTicketsByIds: true };
        case Types.TOUR_TICKET_LIST_ALL_BY_ID_SUCCESS:
            return { ...state, isFetchingAllTourTicketsByIds: false, allTourTicketsByIds: action?.tickets?.data?.data || [] };
        case Types.TOUR_TICKET_LIST_ALL_BY_ID_FAIL:
            return { ...state, isFetchingAllTourTicketsByIds: false, allTourTicketsByIds: [] };
        default:
            return state;
    }
}
